import { Check } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

import { MODULOS } from "./permissoes";

/** Bloco "Permissões de acesso" do cadastro de funcionário: um quadro por módulo
 *  do menu. O módulo marcado vale para ver, criar, editar e apagar o que a tela
 *  dele oferece. `podeConceder(chave)` trava o que quem está editando não tem
 *  (o servidor recusaria: funcionário só libera o que ele mesmo tem). */
export default function PermissoesModulos({
  selecionadas, onToggle, resumo, podeConceder, tudoMarcado, onMarcarTudo, onRestaurar,
}) {
  const total = MODULOS.filter((m) => selecionadas.includes(m.id)).length;
  return (
    <div className="border rounded-xl p-4 bg-muted/20" data-e2e="permissoes-modulos">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div>
          <Label className="text-sm font-semibold">Permissões de acesso</Label>
          <p className="text-[11px] text-muted-foreground">
            {total} de {MODULOS.length} módulos liberados {resumo}
          </p>
        </div>
        <div className="flex items-center gap-1 shrink-0">
          {onRestaurar && (
            <Button variant="ghost" size="sm" onClick={onRestaurar} className="text-xs">Restaurar preset</Button>
          )}
          <Button variant="outline" size="sm" onClick={onMarcarTudo} className="text-xs" data-e2e="perm-marcar-tudo">
            {tudoMarcado ? "Desmarcar tudo" : "Marcar tudo"}
          </Button>
        </div>
      </div>
      <p className="text-[11px] text-muted-foreground mb-3">
        O módulo marcado libera tudo o que a tela dele oferece: ver, criar, editar e apagar.
        Com tudo marcado, o funcionário faz o trabalho de um administrador.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {MODULOS.map((mod) => {
          const ligado = selecionadas.includes(mod.id);
          const travado = !ligado && !podeConceder(mod.id);
          return (
            <button key={mod.id} type="button" disabled={travado} onClick={() => onToggle(mod.id)} data-e2e={`perm-${mod.id}`}
              title={travado ? "Você só pode liberar o que você mesmo tem" : ""}
              className={`flex items-center justify-between gap-2 px-3 py-2 rounded-lg border text-left transition-all ${
                ligado ? "border-primary bg-primary/5 hover:bg-primary/10" : "border-border bg-background hover:border-muted-foreground/40"
              } ${travado ? "opacity-50 cursor-not-allowed" : ""}`}>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium ${ligado ? "text-foreground" : "text-muted-foreground"}`}>{mod.label}</p>
                <p className="text-[10px] text-muted-foreground truncate">{mod.hint}</p>
              </div>
              <div className={`w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 transition ${ligado ? "border-primary bg-primary" : "border-muted-foreground/40"}`}>
                {ligado && <Check className="w-3 h-3 text-white" strokeWidth={3} />}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
